<div class="card">
    <div class="card-body">
        <h5 class="card-title">{{ 'datamanagement.cardTitle' | t }}</h5>
        <h6 class="card-subtitle mb-2 text-muted">{{ 'selectExportTypeBelow' | t }}</h6>

        <hr />

        <mat-checkbox color="primary" name="includeMois" [(ngModel)]="includeChecked"
            >{{ 'includeClosedMoisCheckbox' | t }}</mat-checkbox
        >

        <hr />

        <button
            class="btn btn-default me-2 mb-2"
            (click)="downloadDatamanagement(ExportType.DataManagement)"
        >
            {{ 'datamanagement.datamanagementButton' | t }}
        </button>

        <button
            class="btn btn-default me-2 mb-2"
            (click)="downloadDatamanagement(ExportType.DataManagementAndMoi)"
        >
            {{ 'datamanagement.datamanagementAndMoisButton' | t }}
        </button>
    </div>
</div>
